<template>
  <v-form v-bind="this.$attrs">
    <v-row>
      <v-col cols="12" md="4">
        <v-select
          :items="filteredRoles"
          v-model="role"
          label="Chọn vai trò"
          item-value="id"
          item-text="description"
          return-object
          outlined
          dense
          attach
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="4">
        <v-select
          :items="roleConfigs"
          v-model="config"
          label="Đối với"
          item-value="value"
          item-text="title"
          outlined
          dense
          attach
          hide-details
        ></v-select>
      </v-col>
      <v-col cols="12" md="2">
        <v-btn
          :disabled="!role.id || !config"
          height="40"
          style="background-color: white"
          color="#0D47A1"
          @click="onFilterChanged"
          outlined
        >
          Phân quyền
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { orderBy } from 'lodash-es'

export default {
  components: {},
  data: () => ({
    role: {},
    config: ''
  }),
  computed: {
    ...mapState('role', ['roles']),
    ...mapGetters('constant', ['roleConfigs']),
    filteredRoles() {
      let list = this.roles.filter(r => r.name !== 'Authenticated' && r.name !== 'Public' && r.name !== 'Student')
      list = orderBy(list, ['description', 'asc'])
      return list
    }
  },
  methods: {
    onFilterChanged() {
      const params = {
        role: this.role,
        config: this.config
      }
      this.$emit('onFilterChanged', params)
    }
  }
}
</script>
